import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import i18n, { getI18nLngFromPathname } from "./config";

/**
 * Keeps i18next in sync with the :locale segment when the URL changes via React Router.
 */
export default function I18nLocaleSync() {
    const { pathname } = useLocation();

    useEffect(() => {
        const lng = getI18nLngFromPathname(pathname);
        void i18n.changeLanguage(lng);
    }, [pathname]);

    return null;
}
